<template>
  <div>
    <alert v-if="esignAlerts.length > 0" :show-cta="hasPermission">
      <template slot="icon">
        <img
          src="@/assets/images/common/error-outline-white.svg"
          alt="Error Icon"
        />
      </template>
      <template slot="title">
        <b-icon-exclamation-triangle-fill class="icon-svg mr-2" />
        <router-link
          class="text-danger"
          :to="hasPermission ? { name: 'invoicesEsign' } : '#'"
          >{{ $t('alerts.invoiceList.esignPending.title') }}</router-link
        >
        <span class="d-inline-block d-md-none">({{ esignAlerts.length }})</span>
        <router-link
          :to="hasPermission ? { name: 'invoicesEsign' } : '#'"
          class="text-danger"
          v-track-click
          id="invoices-alerts-esign-pending-mobile"
        >
          <b-icon-arrow-right-short
            class="d-block d-md-none right-arrow"
            font-scale="1.8"
          />
        </router-link>
      </template>
      <template slot="message">
        {{
          $tc('alerts.invoiceList.esignPending.message', esignAlerts.length, {
            count: esignAlerts.length
          })
        }}
      </template>
      <template slot="cta">
        <b-button
          variant="alert"
          size="lg"
          class="text-wrap"
          :to="{ name: 'invoicesEsign' }"
          v-track-click
          id="invoices-alerts-esign-pending"
        >
          {{ $tc('alerts.invoiceList.esignPending.cta', esignAlerts.length) }}
        </b-button>
      </template>
    </alert>
    <alert v-if="basicInfoAlerts.length > 0">
      <template slot="icon">
        <img
          src="@/assets/images/common/error-outline-white.svg"
          alt="Error Icon"
        />
      </template>
      <template slot="title">
        <b-icon-exclamation-triangle-fill class="icon-svg mr-2" />
        <b-link
          class="text-danger"
          @click="filterInvoices(['basic_info_pending'])"
          >{{ $t('alerts.invoiceList.basicInfoPending.title') }}</b-link
        >
        <span class="d-inline-block d-md-none"
          >({{ basicInfoAlerts.length }})</span
        >
        <b-icon-arrow-right-short
          class="float-right d-block d-md-none right-arrow"
          font-scale="1.8"
          @click="filterInvoices(['basic_info_pending'])"
          v-track-click
          id="invoices-alerts-basic-info-pending-mobile"
        />
      </template>
      <template slot="message">
        {{
          $tc(
            'alerts.invoiceList.basicInfoPending.message',
            basicInfoAlerts.length,
            { count: basicInfoAlerts.length }
          )
        }}
      </template>
      <template slot="cta">
        <b-button
          variant="alert"
          size="lg"
          @click="filterInvoices(['basic_info_pending'])"
          v-track-click
          id="invoices-alerts-basic-info-pending"
        >
          {{
            $tc(
              'alerts.invoiceList.basicInfoPending.cta',
              docsMissingAlerts.length
            )
          }}
        </b-button>
      </template>
    </alert>
    <alert v-if="docsMissingAlerts.length > 0">
      <template slot="icon">
        <img
          src="@/assets/images/common/error-outline-white.svg"
          alt="Error Icon"
        />
      </template>
      <template slot="title">
        <b-icon-exclamation-triangle-fill class="icon-svg mr-2" />
        <b-link class="text-danger" @click="filterInvoices(['docs_pending'])">{{
          $t('alerts.invoiceList.docsPending.title')
        }}</b-link>
        <span class="d-inline-block d-md-none"
          >({{ docsMissingAlerts.length }})</span
        >
        <b-icon-arrow-right-short
          class="float-right d-block d-md-none right-arrow"
          font-scale="1.8"
          @click="filterInvoices(['docs_pending'])"
          v-track-click
          id="invoices-alerts-docs-pending-mobile"
        />
      </template>
      <template slot="message">
        {{
          $tc(
            'alerts.invoiceList.docsPending.message',
            docsMissingAlerts.length,
            { count: docsMissingAlerts.length }
          )
        }}
      </template>
      <template slot="cta">
        <b-button
          variant="alert"
          size="lg"
          @click="filterInvoices(['docs_pending'])"
          v-track-click
          id="invoices-alerts-docs-pending"
        >
          {{
            $tc('alerts.invoiceList.docsPending.cta', docsMissingAlerts.length)
          }}
        </b-button>
      </template>
    </alert>
  </div>
</template>
<script>
import Alert from '@/components/Alerts2/Alert'

export default {
  props: ['customerPendingTasks'],
  computed: {
    hasPermission() {
      return this.$store.getters.hasPermission('esign')
    },
    alerts() {
      if (!this.customerPendingTasks) {
        return []
      } else {
        return this.customerPendingTasks.map((task) => {
          return {
            title: 'dude',
            message: 'message'
          }
        })
      }
    },
    basicInfoAlerts() {
      return this.pendingTasks.filter((task) => {
        return task.uid === 'add_basic_info'
      })
    },
    docsMissingAlerts() {
      const invoices = []
      return this.pendingTasks.filter((task) => {
        if (
          task.uid.indexOf('upload_') === 0 &&
          !invoices.includes(task.invoice_id)
        ) {
          invoices.push(task.invoice_id)
          return true
        }
        return false
      })
    },
    esignAlerts() {
      const invoices = []
      return this.pendingTasks.filter((task) => {
        if (
          task.uid.indexOf('_signable_documents') > -1 &&
          !invoices.includes(task.invoice_id)
        ) {
          invoices.push(task.invoice_id)
          return true
        }
        return false
      })
    },
    pendingTasks() {
      return this.customerPendingTasks || []
    }
  },
  components: {
    Alert
  },
  methods: {
    filterInvoices(filters) {
      this.$emit('filter-invoices', filters)
    }
  }
}
</script>
<style lang="scss" scoped>
.right-arrow {
  cursor: pointer;
  float: right;
  font-size: 1.25rem;
}
.text-wrap {
  white-space: normal;
}
.icon-svg {
  width: 0.8rem;
}
</style>
